import { render } from "./setting.vue?vue&type=template&id=516fec7f&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=516fec7f&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516fec7f"]])

export default __exports__